/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationPostureTenant {
    getFixupPrototypeFunction() { return OperationPostureTenant.fixupPrototype; }

    static newInstance(model: Partial<OperationPostureTenant>): OperationPostureTenant {
        let obj = Object.assign(new OperationPostureTenant(), model);
        OperationPostureTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationPostureTenant>): OperationPostureTenant {
        if (!model) return null;
        return OperationPostureTenant.newInstance(<OperationPostureTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationPostureTenant) {
        if (!obj) return;

        models.OperationPostureTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationPostureTenant): boolean {
        Object.setPrototypeOf(obj, OperationPostureTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.alerts === undefined) {
            this.alerts = 0;
        }
        if (this.activities === undefined) {
            this.activities = 0;
        }
        if (this.automation_failures === undefined) {
            this.automation_failures = 0;
        }
    }

    /**
     * Name of the tenant
     */
    tenant_name: string;

    /**
     * Id of the tenant
     */
    tenant_id: string;

    /**
     * alerts count
     */
    alerts: number;

    /**
     * activities cost
     */
    activities: number;

    /**
     * automation count
     */
    automation_failures: number;

}
